import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { KTSVG } from '../../../_metronic/helpers'
import { useDispatch } from 'react-redux'
import useUtils from './useUtils'
import { setTitle } from '../../redux/reducers/mainSlice'
import Accordion from 'react-bootstrap/Accordion'
import FaqListSkeleton from '../../modules/skeleton/FAQListSkeleton'
import Pagination from '../../modules/pagination/Pagination'
import DeleteConfirmation from '../../modules/alert/DeleteConfirmation'

const Faqlist = ({ className }) => {
  const dispatch = useDispatch()
  dispatch(setTitle('FAQs'))

  const [faqs, setFAQs] = useState(null)
  const { fetchFAQs, onDelete, handleEdit } = useUtils()
  const [loading, setLoading] = useState(true)
  const [activeKey, setActiveKey] = useState(null)
  const count = faqs?.count

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [totalPages, setTotalPages] = useState(1)
  
    const [modalVisible, setModalVisible] = useState(false)
    const [selectedId, setSelectedId] = useState(null)

  const navigate = useNavigate()

  const getFAQs = async () => {
    try {
      setLoading(true)
      const offset = (page - 1) * limit
      const result = await fetchFAQs(limit, offset)
      setTotalPages(Math.ceil(result?.count / limit))
      setFAQs(result)
    } catch (error) {
      console.error('Error loading data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getFAQs()
  }, [limit, page])

  const onEdit = async (id) => {
    const values = await handleEdit(id)
    navigate('/faqlist/editfaq', {state: {values}})
  }


  const handleDelete = (id) => {
    setSelectedId(id)
    setModalVisible(true)
  }

  const confirmDelete = async () => {
    if (!selectedId) return
    try {
      setLoading(true)
      const result = await onDelete(selectedId, limit, (page - 1) * limit)
      setFAQs(result)
    } catch (error) {
      console.error('Error deleting FAQ :', error)
    } finally {
      setLoading(false)
      setModalVisible(false)
      setSelectedId(null)
    }
  }

  if (loading) return <FaqListSkeleton/>

  return (
    <>
      <div className={`card ${className}`}>
        <div className='card-header border-0 pt-5'>
          <div className='d-flex align-items-center gap-10'>
            <h3 className='card-title align-items-start flex-column'>
            <span className=' mt-1 text-muted fs-7 '>{count} Items</span>
            </h3>
          </div>
          <div className='card-toolbar'>
            
               <a
           onClick={() => navigate('/faqlist/addFAQ')}
            className='btn btn-sm btn-light-primary'
          >
              Add FAQ
            </a>
          </div>
        </div>
        <div className='p-5'>
          { faqs?.records &&
          faqs?.records?.length > 0 &&
            faqs?.records?.map((val, index) => (
              <Accordion
                key={index}
                activeKey={activeKey}
                onSelect={(e) => setActiveKey(e === activeKey ? null : e)} 
              >
                <Accordion.Item eventKey={index.toString()}>
                  <Accordion.Header>
                    <div className='align-items-center d-flex '>
                    <span className='me-5 fs-1 fw-lighter fs-6'>
                      {activeKey === index.toString() ? '-' : '+'} 
                    </span>
                    <span className='fw-bold fs-6'>
                    {val.question}
                    </span>
                    </div>
                    <div className='ms-auto d-flex'>
                        <a
                         onClick={(e)=>{
                            e.stopPropagation();
                            onEdit(val.id)}}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        >
                          <KTSVG
                            path='/media/icons/duotune/art/art005.svg'
                            className='svg-icon-3 svg-icon-primary'
                          />
                        </a>
                        <a
                          onClick={(e)=>{
                            e.stopPropagation()
                            handleDelete(val.id)}}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                        >
                          <KTSVG
                            path='/media/icons/duotune/general/gen027.svg'
                            className='svg-icon-3 text-danger'
                          />
                        </a>
                        </div>
                   

                  </Accordion.Header>
                  <Accordion.Body>
                    <span className='fs-6'>{val.answer}</span>
                    </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            ))}
        </div>
        <div className='d-flex align-items-center justify-content-between pb-5 ps-10 pe-5'>
          <div className='d-flex align-items-center gap-3'>
            <span className='fs-6 text-muted'>Show</span>
            <div>
              <select
                defaultValue={limit}
                className='form-select form-select-solid text-muted select2-hidden-accessible'
                onChange={(e) => {
                  setPage(1)
                  setLimit(e.target.value)
                }}
              >
                <option>10</option>
                <option>20</option>
                <option>50</option>
                <option>100</option>
              </select>
            </div>
          </div>
          <DeleteConfirmation
            isVisible={modalVisible}
            message='Are you sure you want to delete FAQ?'
            onConfirm={confirmDelete}
            onCancel={() => setModalVisible(false)}
          />
          <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
        </div>
      </div>
    </>
  )
}

export default Faqlist
